<template>
  <section class="about-us">
    <div class="container">
      <div class="about-grid">
        <div class="about-image-wrapper">
          <div class="image-overlay">
            <img src="@/assets/images/homepage/arkayl-about-us.jpg" alt="Shield Glow" class="shield-icon" />
          </div>
        </div>
        <div class="about-content">
          <h4 class="brand-tag">{{ $t('originStoryTitle') }}</h4>
          <h2>{{ $t('originHeadline') }}</h2>
          <p>{{ $t('originStoryParagraphTwo') }}</p>
          <div class="values-list">
            <div class="value-item">
              <span class="value-icon">⚔️</span>
              <div>
                <h5>{{ $t('originValueTitle_1') }}</h5>
                <p>{{ $t('originValueDescription_1') }}</p>
              </div>
            </div>
            <div class="value-item">
              <span class="value-icon">🤝</span>
              <div>
                <h5>{{ $t('originValueTitle_2') }}</h5>
                <p>{{ $t('originValueDescription_2') }}</p>
              </div>
            </div>
          </div>
          <router-link to="/contact" class="primary-button">{{ $t('startAlliance') }}</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.about-us {
  position: relative;
  margin: 0 0 120px 0;
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 60px;
  align-items: center;
}

.image-overlay img {
  width: 100%;
  border-radius: 30px;
}

.about-image-wrapper {
  position: relative;
  border-radius: 20px;
  background: linear-gradient(135deg, var(--primary-color) 0%, #000 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  aspect-ratio: 1/1;
}

.image-overlay {
  height: 100%;
}

.visual-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.shield-icon {
  font-size: 8rem;
  filter: drop-shadow(0 0 15px rgba(43, 189, 211, 0.4));
}

.stat-card {
  position: absolute;
  bottom: 30px;
  right: -20px;
  background: var(--secondary-color);
  padding: 25px 40px;
  border-radius: 15px;
  color: #fff;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.stat-number {
  display: block;
  font-family: var(--secondary-font);
  font-size: 1.5rem;
  font-weight: 800;
  text-transform: uppercase;
}

.stat-text {
  font-size: 0.9rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.brand-tag {
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 0.5rem;
  margin-top: 0;
}

.highlight {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--primary-color);
  border-left: 4px solid var(--secondary-color);
  padding-left: 20px;
  margin: 2rem 0;
}

.values-list {
  display: grid;
  gap: 20px;
  margin: 30px 0;
}

.value-item {
  display: flex;
  gap: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  transition: transform 0.3s ease;
  border: 1px solid #edf2f7;
}

.value-item:hover {
  transform: translateX(10px);
}

.value-icon {
  font-size: 1.5rem;
  background: rgba(43, 189, 211, 0.1);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.value-item h5 {
  margin: 0 0 5px 0;
}

.value-item p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-color);
}

@media (min-width: 992px) {
  .about-grid {
    grid-template-columns: 1fr 1fr;
  }

}

@media (max-width: 768px) {
  .stat-card {
    right: 20px;
    padding: 15px 25px;
  }

  h2 {
    font-size: 2.25rem;
  }
}
</style>
